import { type BarShapeProps, Rectangle } from 'recharts';

const MIN_BAR_PX = 4;

export const CustomBar = (props: BarShapeProps) => {
  const { x, y, width, height, value, ...shapeProps } = props;

  if (value !== 0 && height > MIN_BAR_PX) {
    return <Rectangle {...props} />;
  }

  return <Rectangle x={x} y={y - MIN_BAR_PX} width={width} height={MIN_BAR_PX} {...shapeProps} />;
};
